import {createContext} from 'react';
import type {User} from 'oidc-client-ts';

export interface AuthContext {
  user: User | null;
  logout: () => Promise<void>;
}

export const AuthenticationContext = createContext<AuthContext | undefined>(undefined);
